import React, {MouseEvent, useState} from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import DotsVertical from "mdi-material-ui/DotsVertical";
import {Delete, Edit} from "@mui/icons-material";
import {CourtHouseDTO, EditCourtHouseDTO} from "../api/dtos";
import {useSelector} from "react-redux";
import {AppState} from "../store";
import Tooltip from "@mui/material/Tooltip";
import {adminOrHasPermission} from "../shared/utils";

interface CourtHouseActionProps {
    courtHouse: CourtHouseDTO;
    onEdit: (courtHouse: CourtHouseDTO) => void;
    onDelete: (courtHouse: CourtHouseDTO) => void;
    handleEdit?: (updatedCourtHouse: EditCourtHouseDTO) => void;
}

const CourtHouseAction: React.FC<CourtHouseActionProps> = ({
                                                               courtHouse,
                                                               onEdit,
                                                               onDelete,
                                                               handleEdit,
                                                           }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const user = useSelector((state: AppState) => state.auth.userWithToken?.user);
    const open = Boolean(anchorEl);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onMenuItemClick = (action: () => void) => {
        handleClose();
        action();
    };

    if (!user) return null;

    const editCourtHouse = () => onMenuItemClick(() => onEdit(courtHouse));
    const deleteCourtHouse = () => onMenuItemClick(() => onDelete(courtHouse));

    const courtHouseEdit = adminOrHasPermission(user);
    const courtHouseDelete = adminOrHasPermission(user);
    const hasAtLeastOneAction = courtHouseEdit || courtHouseDelete;

    return hasAtLeastOneAction
        ? (
            <>
                <IconButton
                    aria-controls={open ? 'court-house-action-menu' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                    size='small'
                    aria-label='settings'
                    sx={{color: 'text.secondary'}}>
                    <DotsVertical/>
                </IconButton>
                <Menu
                    id="court-house-action-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}>
                    {courtHouseEdit && (
                        <MenuItem onClick={editCourtHouse}>
                            <IconButton size='small' aria-label='edit' sx={{color: 'text.secondary'}}>
                                <Edit/>
                            </IconButton>
                            Düzenle
                        </MenuItem>
                    )}
                    {courtHouseDelete && (
                        <MenuItem onClick={deleteCourtHouse}>
                            <IconButton size='small' aria-label='delete' sx={{color: 'text.secondary'}}>
                                <Delete/>
                            </IconButton>
                            Sil
                        </MenuItem>
                    )}
                </Menu>
            </>
        ) : (
            <Tooltip title="Bu işlem için yetkiniz yok!">
                <IconButton
                    size="small"
                    aria-label="settings"
                    sx={{color: 'action.disabled'}}>
                    <DotsVertical/>
                </IconButton>
            </Tooltip>
        );
};

export default CourtHouseAction;
